import { RefObject, useEffect, useState } from 'react';
import { WizardStepData } from '../data/types';

export const useElementHeight = (
  refs: Array<RefObject<HTMLDivElement>>,
  data: Record<number, WizardStepData>,
): number[] => {
  const [heights, setHeights] = useState<number[]>([]);

  useEffect(() => {
    const updateHeights = () =>
      setHeights(refs.map((ref) => ref.current?.clientHeight || 0));

    updateHeights();

    window.addEventListener('resize', updateHeights);
    return () => window.removeEventListener('resize', updateHeights);
  }, [data]);

  return heights;
};
